import { useEffect } from 'react';
import { useLiveRef } from '@lumahealthhq/ui-utils';
import useSocket from './useSocket';

/**
 * Subscribe to socket events data
 *
 * @param socketEvents Event names we want to subscribe to
 * @param callback Callback to handle the array of datas
 */
export default function useSocketEvents(socketEvents, callback) {
  const socket = useSocket();

  // Avoid passing unstable reference values into `useEffect` dependency array.
  const onSocketCallback = useLiveRef(callback);
  const socketEventsString = socketEvents.join(',');
  useEffect(() => {
    const $socketEvents = socketEventsString ? socketEventsString.split(',') : [];
    if (!socket || !$socketEvents.length) {
      return undefined;
    }
    const onSocket = (callbackData, ackCallback) => {
      ackCallback == null ? void 0 : ackCallback();
      onSocketCallback.current(callbackData);
    };
    $socketEvents.forEach(event => {
      // Emit an initial event to signal the websocket will start receiving and sending events
      socket.emit('subscribe', event);
      socket.on(event, onSocket);
    });
    return () => {
      $socketEvents.forEach(event => {
        // Emit an initial event to signal the websocket will stop receiving and sending events
        socket.emit('unsubscribe', event);
        socket.off(event, onSocket);
      });
    };
  }, [socket, socketEventsString, onSocketCallback]);
}